export default __webpack_public_path__ + "static/media/check.b4221b02.png";